import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import { formatMomentDate } from "../../../utils/dateHelper";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import InputField from "../../form/InputField";

const EducationModal = ({ onClose, onSubmit, education, isLoading }) => {
  const [formData, setFormData] = useState({
    university: "",
    degree: "",
    field_of_study: "",
    from_date: "",
    to_date: "",
    // description: "",
  });
  const toast=useToast();
  useEffect(() => {
    if (education) {
      setFormData({
        university: education.university || "",
        degree: education.degree || "",
        field_of_study: education.field_of_study || "",
        from_date: education.from_date ? formatMomentDate(education.from_date, "YYYY-MM-DD") : "",
        to_date: education.to_date ? formatMomentDate(education.to_date, "YYYY-MM-DD") : "",
        // description: education.description || "",
      });
    } else {
      setFormData({
        university: "",
        degree: "",
        field_of_study: "",
        from_date: "",
        to_date: "",
        // description: "",
      });
    }
  }, [education]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!formData.university || !formData.degree || !formData.from_date || !formData.to_date) {
      toast.error("Please fill all required fields");
      return;
    }

    const todayStr = new Date().toLocaleDateString('en-CA');
    if (formData.from_date && formData.from_date > todayStr) {
      toast.error("Start date cannot be in the future");
      return;
    }

    if (formData.to_date && formData.from_date > formData.to_date) {
      toast.error("End date must be after or equal to start date");
      return;
    }

    onSubmit(formData);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12 mb-3">
            <InputField
              label={{ name: "School" }}
              required
              input={{
                type: "text",
                name: "university",
                value: formData.university,
                onChange: handleChange,
                placeholder: "Ex: Boston University",
              }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <InputField
              label={{ name: "Degree" }}
              required
              input={{
                type: "text",
                name: "degree",
                value: formData.degree,
                onChange: handleChange,
                placeholder: "Ex: Bachelor's",
              }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <InputField
              label={{ name: "Field of Study" }}
              input={{
                type: "text",
                name: "field_of_study",
                value: formData.field_of_study,
                onChange: handleChange,
                placeholder: "Ex: Business",
              }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <InputField
              label={{ name: "Start Date" }}
              required
              input={{
                type: "date",
                name: "from_date",
                value: formData.from_date,
                onChange: handleChange,
                max: new Date().toLocaleDateString('en-CA'),
              }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <InputField
              label={{ name: "End Date" }}
              required
              input={{
                type: "date",
                name: "to_date",
                value: formData.to_date,
                onChange: handleChange,
                min: formData.from_date,
                max: new Date().toLocaleDateString('en-CA'),
              }}
            />
          </div>
          {/* <div className="col-md-12 mb-3">
            <InputField
              label={{ name: "Description" }}
              input={{
                as: "textarea",
                rows: 3,
                name: "description",
                value: formData.description,
                onChange: handleChange,
                placeholder: "Describe your studies, awards, etc.",
              }}
            />
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          type="button"
          variant="outline"
          title="Cancel"
          onClick={onClose}
          disabled={isLoading}
        />
        <CommonButton
          type="submit"
          variant="primary"
          title={education ? "Update" : "Save"}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(EducationModal);
